<div class="textarea-wrapper">
  <label *ngIf="label">{{label}}</label>

  <textarea [required]="required"
            [(ngModel)]="value"
            [disabled]="disabled">
  </textarea>
</div>
